import { fetchApiData } from './ApiCalls';
import { COMPANY_SCOPES } from '../urls';

/**
 * KAM email from GET company_scopes top-level `kam: [{ id, name, email, role }]`.
 * Prefer first entry; empty string when absent.
 */
export const resolveKamEmailFromCompanyScopes = data => {
  if (!data || typeof data !== 'object') return '';
  const kam = data.kam;
  if (Array.isArray(kam) && kam.length) {
    const email = kam[0]?.email;
    return email ? String(email).trim().toLowerCase() : '';
  }
  if (kam && typeof kam === 'object' && kam.email) {
    return String(kam.email).trim().toLowerCase();
  }
  return '';
};

/** True when company_scopes payload includes a KAM with an id or email. */
export const companyScopesHasKam = data => {
  if (!data || typeof data !== 'object') return false;
  const kam = data.kam;
  if (Array.isArray(kam)) return !!(kam[0]?.id || kam[0]?.email);
  return !!(kam?.id || kam?.email);
};

/** First KAM person object from company_scopes `kam` array (or single object). */
export const resolveKamPersonFromCompanyScopes = data => {
  if (!data || typeof data !== 'object') return null;
  const kam = data.kam;
  const entry = Array.isArray(kam) ? kam[0] : kam;
  if (!entry || typeof entry !== 'object') return null;
  const id = entry.id != null && entry.id !== '' ? String(entry.id) : null;
  const email = entry.email ? String(entry.email).trim() : '';
  const name = entry.name ? String(entry.name).trim() : '';
  if (!id && !email) return null;
  return { id, name, email };
};

/** Fetch company_scopes and return the linked KAM email (if any). */
export const fetchCompanyScopesKamEmail = async email => {
  const normalized = typeof email === 'string' ? email.trim().toLowerCase() : '';
  if (!normalized) return '';
  const scopesRes = await fetchApiData({
    endpoint: COMPANY_SCOPES,
    apiRequest: 'GET',
    params: { user_email: normalized }
  });
  if (scopesRes?.error || scopesRes?.data == null) return '';
  return resolveKamEmailFromCompanyScopes(scopesRes.data);
};

/**
 * Prefill helper: keep an existing enterprise/FS KAM; use scope-record KAM only when empty.
 * Never silently substitute a different person over enterprise_info.
 */
export const preferExistingKamOrScope = (existing, scopeEmail) => {
  const existingNorm =
    typeof existing === 'string'
      ? existing.trim().toLowerCase()
      : Array.isArray(existing)
        ? String(existing[0] || '')
            .trim()
            .toLowerCase()
        : '';
  if (existingNorm) return existingNorm;
  const scopeNorm = typeof scopeEmail === 'string' ? scopeEmail.trim().toLowerCase() : '';
  return scopeNorm || '';
};
